import { TripPlannerPage } from '@apps/main/new-desktop/core/models/navigation';

import { buildRouteQuery } from './propsRouteBuilder/legacy/buildRouteQuery';
import type { PropsRouteBuilder } from './propsRouteBuilder/legacy/router';
import { Route } from './propsRouteBuilder/legacy/router';

const TripOverviewPrintPageComponent: () => Promise<unknown> = () =>
  import('../../new-desktop/pages/tripOverview/TripOverviewPrintPage.vue');

const TripOverviewPageComponent: () => Promise<unknown> = () =>
  import('../../new-desktop/pages/tripOverview/TripOverviewPage.vue');

const FlightListPageComponent: () => Promise<unknown> = () =>
  import('../../new-desktop/pages/flights/FlightsListsPage.vue');

const FerryListPageCompoent: () => Promise<unknown> = () =>
  import('../../new-desktop/pages/ferry/FerryListPage.vue');

const HotelSelectionPageComponent: () => Promise<unknown> = () =>
  import('../../new-desktop/pages/hotelSelection/HotelSelectionPage.vue');

const ActivitySelectionPageComponent: () => Promise<unknown> = () =>
  import('../../new-desktop/pages/activitySelection/ActivitySelectionPage.vue');

const HotelDetailsPageComponent: () => Promise<unknown> = () =>
  import('../../new-desktop/pages/hotelDetails/HotelDetailsPage.vue');

const ActivityDetailsPageComponent: () => Promise<unknown> = () =>
  import('../../new-desktop/pages/activityDetails/ActivityDetailsPage.vue');

const CarTripPageComponent: () => Promise<unknown> = () =>
  import('../../new-desktop/pages/carTrip/CarTripPage.vue');

const tripOverviewRoute = {
  name: TripPlannerPage.TripOverview,
  path: '/travel/plan/overview',
  component: TripOverviewPageComponent,
};

const tripOverviewPrintRoute = {
  name: TripPlannerPage.TripOverviewPrint,
  path: '/travel/plan/overview-print',
  component: TripOverviewPrintPageComponent,
};

const flightListRoute = {
  name: TripPlannerPage.FlightList,
  path: '/travel/plan/flights',
  component: FlightListPageComponent,
};

const ferryListRoute = {
  name: TripPlannerPage.FerryList,
  path: '/travel/plan/ferry',
  component: FerryListPageCompoent,
};

const hotelSelectionRoute = {
  name: TripPlannerPage.HotelSelection,
  path: '/travel/plan/hotel-selection/:ingredientIndex',
  component: HotelSelectionPageComponent,
  children: [
    {
      name: TripPlannerPage.HotelDetailsInHotelSelection,
      path: 'hotel-details/:hotelCode',
      component: HotelDetailsPageComponent,
    },
  ],
};

const activitySelectionRoute = {
  name: TripPlannerPage.ActivitySelection,
  path: '/travel/plan/activity-selection/:ingredientIndex',
  component: ActivitySelectionPageComponent,
  children: [
    {
      name: TripPlannerPage.ActivityDetailsInActivitySelection,
      path: 'activity-details/:activityCode',
      component: ActivityDetailsPageComponent,
    },
  ],
};

const carTripRoute = {
  name: TripPlannerPage.CarTrip,
  path: '/travel/plan/car-trip',
  component: CarTripPageComponent,
};

const baseTripPlannerRoute: PropsRouteBuilder = Route()
  .withName(TripPlannerPage.BaseURL)
  .withPath('/travel/plan')
  .useComponent(() => import('../../components/TripPlannerRoot.vue'))
  .withChildren([
    tripOverviewRoute,
    tripOverviewPrintRoute,
    flightListRoute,
    ferryListRoute,
    hotelSelectionRoute,
    activitySelectionRoute,
    carTripRoute,
  ]);

export const TripPlannerRoute = buildRouteQuery(baseTripPlannerRoute).build();
